import { SyncRunResultDTO } from "@app/api/generated";
import { IRunCounter } from "@app/util/run-counters";

/**
 * The seven run counters, in a fixed display order, shared by the table cell and the detail sidebar.
 * Colours mirror the event actions: created = blue, set-offline/deleted = yellow, errors = red,
 * the rest grey.
 */
export const RUN_COUNTERS: Array<IRunCounter<SyncRunResultDTO>> = [
  {
    key: "pagesCreated",
    labelId: "productPageSync.counter.created",
    shortId: "productPageSync.counter.createdShort",
    color: "blue"
  },
  {
    key: "pagesSetOnline",
    labelId: "productPageSync.counter.online",
    shortId: "productPageSync.counter.onlineShort",
    color: "green"
  },
  {
    key: "pagesSetPendingOffline",
    labelId: "productPageSync.counter.grace",
    shortId: "productPageSync.counter.graceShort",
    color: "grey"
  },
  {
    key: "pagesResetGrace",
    labelId: "productPageSync.counter.graceReset",
    shortId: "productPageSync.counter.graceResetShort",
    color: "grey"
  },
  {
    key: "pagesSetOffline",
    labelId: "productPageSync.counter.offline",
    shortId: "productPageSync.counter.offlineShort",
    color: "yellow"
  },
  {
    key: "pagesDeleted",
    labelId: "productPageSync.counter.deleted",
    shortId: "productPageSync.counter.deletedShort",
    color: "yellow"
  },
  {
    key: "errorCount",
    labelId: "productPageSync.counter.errors",
    shortId: "productPageSync.counter.errorsShort",
    color: "red"
  }
];
